<!-- Example usage:
  <app-alert-message 
    type="info" 
    message="<a class='link text-blue-700 underline' target='_blank' href='/docs'>Click here</a> to access the documentation"
    iconTooltip="Information message">
  </app-alert-message>

  <app-alert-message 
    type="warning" 
    message="<span class='underline'>Important:</span> <a class='link text-yellow-700 underline' href='/terms'>terms</a> before proceeding"
    iconTooltip="Warning message"
    iconPlacement="right">
  </app-alert-message>
-->

<div [class]="alertClasses" class="flex items-center gap-2 will-change-transform">
  @if (iconPlacement === 'left') {
    <i [class]="icon || defaultIcon" [title]="iconTooltip" class="text-lg select-none"></i>
  }
  <span class="font-bold text-sm select-text" [innerHTML]="message"></span>
  @if (iconPlacement === 'right') {
    <i [class]="icon || defaultIcon" [title]="iconTooltip" class="text-lg select-none"></i>
  }
</div>
